import React, { Component } from 'react';
import {Link} from 'react-router-dom';

export default () => {
  return (
    <section className="psre-empat">
      <div className="container">
        <table className="table-borderless w-100 mb-5">
          <tr>
            <td>
              <p className="mb-0" style={{fontSize: '14px', fontWeight: '600'}}>Video dari PSrE</p>
            </td>
            <td className="tb" style={{width: '65%'}}>
              <div style={{borderTop: '1px solid rgba(49, 49, 49, 0.12)', width: '100%'}}></div>
            </td>
            <td class="text-right">
              <Link to="/event/gallery" style={{fontSize: '13px',  fontWeight: '600', color: '#0085C7'}}>Lihat Semua Video</Link>
            </td>
          </tr>
        </table>
        <div className="row">
          <div className="col-lg-8 col-md-8 col-sm-12 col-12">
            <div className="embed-responsive embed-responsive-16by9 mb-4" style={{borderRadius: '5px'}}>
              <iframe title='1' className="embed-responsive-item" src="https://www.youtube.com/embed/zgEPTYI126o" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-12">
            <div className="embed-responsive embed-responsive-16by9 mb-4" style={{borderRadius: '5px'}}>
              <iframe title='2' className="embed-responsive-item" src="https://web.facebook.com/plugins/video.php?href=https%3A%2F%2Fweb.facebook.com%2Fprovjateng%2Fvideos%2F673436489801153%2F&show_text=0&width=560" style={{border: 'none', overflow: 'hidden'}} scrolling="no" frameborder="0" allowTransparency="true" allowFullScreen="true"></iframe>
            </div>
            <div className="embed-responsive embed-responsive-16by9 mb-4" style={{borderRadius: '5px'}}>
              <iframe title='3' className="embed-responsive-item" src="https://www.youtube.com/embed/Vx85ekwwlnY" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
            </div>
            {/* <div className="embed-responsive embed-responsive-16by9 mb-4" style={{bordeRradius:' 5px'}}>
              <iframe className="embed-responsive-item" src="https://www.youtube.com/embed/G6G0Hlws76M" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
            </div>
            <div className="embed-responsive embed-responsive-16by9 mb-4" style={{bordeRradius:' 5px'}}>
              <iframe className="embed-responsive-item" src="https://www.youtube.com/embed/KarR5yHRwAU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  )
}
